import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import PropTypes from "prop-types";
import {Globals} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";

const ReactHookFormDropdownLetterboxToUsers = (props) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        //Gets all users in an org that can recieve letterbox items
       //const url = Globals.APIFolder + '/organisation/current/users?user_type=letterbox_contacts' ;
        const url = Globals.APIFolder + '/users/all/relations?direction=to' ;

        genericListboxFetch( {url:url, keyFieldName: 'user_id', labelFieldName: 'name', additionalFields:['idusers']}).then((response) =>
        {
            setData ( { loading: false, items: response }) ;
        }) ;
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}}) : renderDropdown(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}})
    )
}

export default ReactHookFormDropdownLetterboxToUsers;

ReactHookFormDropdownLetterboxToUsers.defaultProps =
{
    defaultClassName: ''
}

ReactHookFormDropdownLetterboxToUsers.propTypes = {
    onChange: PropTypes.func.isRequired
};
